import { createBrowserRouter } from "react-router";
import { BASE_PATH } from "src/basepath";
import LogoutUtilityPage from "src/pages/AuthPages/LogoutUtilityPage/LogoutUtilityPage";
import {
  appRoutes,
  envPageRoutes,
  redirectRoutes,
} from "src/utils/appRoutes/appRoutes";
import { AppErrorBoundary } from "./components/AppErrorBoundary/AppErrorBoundary";
import { AppLoader } from "./components/AppLoader/AppLoader";
import { AppMainWrapper } from "./components/AppMainWrapper/AppMainWrapper";
import { AppRouterError } from "./components/AppRouterError/AppRouterError";
import { OuterRouteErrorBoundary } from "./components/OuterRouteErrorBoundary/OuterRouteErrorBoundary";
import {
  authRouterLoader,
  envNotFoundRedirectRouterLoader,
  envRedirectRouterLoader,
  loginRouterLoader,
  taskRedirectRouterLoader,
  tokenRouterLoader,
  transformationRedirectRouterLoader,
} from "./loaders";

export const router = createBrowserRouter(
  [
    {
      errorElement: <OuterRouteErrorBoundary />,
      children: [
        {
          path: "logout",
          element: <LogoutUtilityPage />,
        },
        {
          path: "/",
          element: <AppMainWrapper />,
          children: [
            {
              errorElement: <AppErrorBoundary />,
              loader: authRouterLoader,
              children: [
                {
                  path: "",
                  loader: envRedirectRouterLoader,
                  element: <AppLoader />,
                  errorElement: <AppRouterError />,
                  shouldRevalidate: () => true,
                  children: [
                    appRoutes.welcome.route,
                    appRoutes["super-admin"].route,
                    {
                      ...redirectRoutes["task-by-id"].route,
                      loader: taskRedirectRouterLoader,
                    },
                    {
                      ...redirectRoutes["task-by-name-and-pit"].route,
                      loader: taskRedirectRouterLoader,
                    },
                    {
                      ...redirectRoutes["compute-by-name-and-pit"].route,
                      loader: taskRedirectRouterLoader,
                    },
                    {
                      ...redirectRoutes["transform-by-id"].route,
                      loader: transformationRedirectRouterLoader,
                    },
                    {
                      path: "envs/:env_name",
                      children: [
                        {
                          index: true,
                          path: "",
                          lazy: appRoutes.dashboard.lazy,
                        },
                        ...envPageRoutes,
                        { path: "*", loader: envNotFoundRedirectRouterLoader },
                      ],
                    },
                    { path: "*", loader: envRedirectRouterLoader },
                  ],
                },
                appRoutes["compare-runs"].route,
                appRoutes.users.route,
                appRoutes.license.route,
                { path: "*", loader: envRedirectRouterLoader },
              ],
            },
          ],
        },
        {
          path: "login",
          lazy: appRoutes.login.lazy,
          loader: loginRouterLoader,
        },
        {
          path: "token/:token",
          id: "token",
          loader: tokenRouterLoader,
          lazy: appRoutes.token.lazy,
        },
        appRoutes["set-password"].route,
        appRoutes.signup.route,
        appRoutes["signup-thank-you"].route,
        appRoutes["signup-set-password"].route,
        appRoutes["forgot-password"].route,
        appRoutes["change-password"].route,
      ],
    },
  ],
  { basename: BASE_PATH }
);
